import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
dayjs.extend(isToday);

/**
 * Formats a date to a relative date time string.
 *
 * Returns the time if the date is today, the day and month if
 * it is within the last year and the full date if it is older.
 *
 * @param {dayjs.ConfigType} date - Any object that dayjs can parse
 * @returns {string}
 */
export function formatRelativeDateTime(date) {
  const now = dayjs();
  const dateObject = dayjs(date);

  if (!dateObject.isValid()) {
    return "Invalid date";
  }

  if (dateObject.isToday()) {
    return dateObject.format("HH:mm");
  }

  if (dateObject.isAfter(now.subtract(1, "year"))) {
    return dateObject.format("D MMM");
  }

  return dateObject.format("DD/MM/YYYY");
}
